import { Box, Text } from '@opendoor/bricks-next';

const SellYourWayElement = () => {
  return (
    <Box gap="$8x" $smallerThanMD={{ gap: '$4x' }}>
      <Box
        backgroundColor="$backgroundSecondary"
        borderRadius="$12x"
        paddingVertical="$16x"
        paddingHorizontal="$12x"
      >
        <Text
          tag="p"
          typography="$labelSmall"
          color="$contentTertiary"
          $smallerThanMD={{ fontSize: '$labelXsmall' }}
          mb={8}
        >
          Option 1
        </Text>
        <Text
          tag="h2"
          typography="$subheaderMedium"
          $smallerThanMD={{ fontSize: '$subheaderSmall' }}
          mb={8}
        >
          Sell to Opendoor
        </Text>
        <Text tag="p" typography="$bodyLarge" $smallerThanMD={{ fontSize: '$bodySmall' }}>
          Direct sale to Opendoor with an all-cash offer.
        </Text>
      </Box>

      <Box
        backgroundColor="$backgroundSecondary"
        borderRadius="$12x"
        paddingVertical="$16x"
        paddingHorizontal="$12x"
      >
        <Box flexDirection="row" justifyContent="space-between" gap="$6x" mb={8}>
          <Text
            tag="p"
            color="$contentTertiary"
            typography="$labelSmall"
            $smallerThanMD={{ fontSize: '$labelXsmall' }}
            my="auto"
          >
            Option 2
          </Text>
          <Box
            backgroundColor="$backgroundAccentBrand"
            px={12}
            py={4}
            height="100%"
            borderRadius="$8x"
          >
            <Text tag="p" typography="$labelXsmall" color="$contentInversePrimary">
              New
            </Text>
          </Box>
        </Box>
        <Text
          tag="h2"
          typography="$subheaderMedium"
          $smallerThanMD={{ fontSize: '$subheaderSmall' }}
          mb={8}
        >
          List with Opendoor
        </Text>
        <Text tag="p" typography="$bodyLarge" $smallerThanMD={{ fontSize: '$bodySmall' }}>
          Traditional sale with our all-cash offer included.
        </Text>
      </Box>
    </Box>
  );
};

export default SellYourWayElement;
